import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import TileHeadLineIcon from "./TileHeadlineIcon";

const TileHeadline = props => {
  const { className, children, ...other } = props;

  return (
    <span className={clsx("em-c-tile__headline", className)} {...other}>
      {children}
    </span>
  );
};

TileHeadline.Icon = TileHeadLineIcon;

TileHeadline.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

TileHeadline.defaultProps = {
  className: "",
  children: null
};

export default TileHeadline;
